const GraphDataCalculation = async response => {
  const calculatedGraphData = [];
  for (let iterator = 0; iterator < response.length; iterator++) {
    const right_answered = response[iterator]['esg_questions.esg_question_stats.userAnswerCount'];
    const total_question = response[iterator]['esg_questions.esg_question_stats.userAttemptCount'];
    const user_graph_val = parseInt((right_answered / total_question) * 100, 10);
    await calculatedGraphData.push(user_graph_val);
  }
  return calculatedGraphData;
};
export default GraphDataCalculation;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/Config/GraphDataCalculation.js